




















import {Component, Prop, Vue} from 'vue-property-decorator';
import {AudioElementState} from '@/components/Player.vue';

@Component
export default class PlaybackControls extends Vue
{
  @Prop()
  audioElementState!: AudioElementState;

  get isSongSelected()
  {
    return this.audioElementState.currentSrc !== null;
  }

  get currentProgress()
  {
    if (this.audioElementState.duration === 0)
    {
      return 0;
    }

    return this.audioElementState.currentTime / this.audioElementState.duration;
  }

  get playIconUrl()
  {
    return this.audioElementState.isPlaying ? 'img/pause.svg' : 'img/play.svg';
  }

  seekTo(event: MouseEvent)
  {
    let progressBarElement = event.target as HTMLProgressElement;
    this.$emit('seek-to', event.offsetX / progressBarElement.clientWidth);
  }
}
